import React from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonTitle,
  IonContent
} from "@ionic/react";
import { arrowBack } from "ionicons/icons";
import { IonIcon } from "@ionic/react";
import GliderListRO from "../../glider/GliderListRO";
import { findGliderFce } from "../../common/FindFuctions";

/**
 * Glider selection view component
 */
export const GliderSelectionView = ({
  type,
  active,
  onBack,
  onSelectGlider
}) => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons>
            <IonButton slot="start" color="primary" onClick={onBack}>
              <IonIcon icon={arrowBack} /> Zpět
            </IonButton>
            <IonTitle>Vyber kluzák</IonTitle>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <GliderListRO
          key="gliderList"
          type={type}
          setGlider={onSelectGlider}
          active={active?.glider}
          findFce={findGliderFce}
        />
      </IonContent>
    </IonPage>
  );
};

